import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import CheckoutHeaderSkeleton from './CheckoutHeaderSkeleton';
import useMediaQuery from '../../../../utils/hooks/mediaQuery.hook';
import SkeletonElement from '../../../../components/skeletons/SkeletonElement';
import CheckoutFormSkeleton from './CheckoutFormSkeleton';
import ArticlesPreviewSkeleton from '../../../../components/skeletons/ArticlesPreviewSkeleton';

const CheckoutSkeleton = () => {
  const { isMobile } = useMediaQuery();

  return (
    <div className="min-vh-100 d-flex flex-column">
      <CheckoutHeaderSkeleton />
      <Container>
        <Row className="my-md-5">
          <Col xs={12} md={6}>
            <div className="checkout-section">
              {!isMobile && (
                <div className="checkout-section-title p-3">
                  <SkeletonElement type="input" className="w-75 mx-auto" />
                </div>
              )}
              <CheckoutFormSkeleton />
            </div>
          </Col>
          {!isMobile && (
            <Col md={6}>
              <div className="checkout-section">
                <div className="checkout-section-title p-3">
                  <SkeletonElement type="input" className="w-75 mx-auto" />
                </div>
                <ArticlesPreviewSkeleton />
              </div>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default CheckoutSkeleton;
